import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useAtomValue } from 'jotai';

import { deviceAtom } from '@/atoms/device';
import { pageName } from '@/constants/nlog';
import { pageDetailType } from '@pkgtour-workspace/common/dist/constants/nlog';

interface NlogPageViewProviderProps {
  children: React.ReactNode;
}

const NlogPageViewProvider: React.FC<NlogPageViewProviderProps> = ({ children }) => {
  const { pathname } = useRouter();
  const device = useAtomValue(deviceAtom);

  useEffect(() => {
    window.ntm.push({
      event: 'pageview',
      pageName: pageName[pathname] || pathname,
      device: device === 'mo' ? 'mobile' : 'pc',
      pageDetailType: pageDetailType[pathname],
    });
  }, [pathname, device]);

  return <>{children}</>;
};

export default NlogPageViewProvider;
